<template>
  <div class="achievement">
    <CommonLayout>
      <div slot="header">
        <h3>军工三证</h3>
        <h3 class="down-data pointer" @click="downloadData">资料管理</h3>
      </div>
      <div slot="container">
        <div class="achievement-search">
          <!-- <el-button
            type="success"
            icon="el-icon-plus"
            @click="addAch"
            style="background: #623AA2; border: none;"
          >新增</el-button>-->
          <el-button icon="el-icon-delete" type="danger" @click="deleteAll"
          >批量删除
          </el-button
          >
          <!-- <el-button
            type="primary"
            class="exportOut"
            icon="el-icon-download"
            @click="exportOut"
          >导出</el-button>-->
          <!--        <el-popover placement="bottom" width="300" v-model="visible">
            <el-date-picker
              style="width:100%"
              v-model="times"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <div style="text-align: right; margin-top: 10px">
              <el-button size="mini" type="text" @click="()=>{visible = false;times = null}">取消</el-button>
              <el-button type="primary" size="mini" @click="exportOut">确定</el-button>
            </div>
            <el-button
              class="exportOut"
              style="margin-left:10px;"
              slot="reference"
              type="primary"
              icon="el-icon-download"
            >导出</el-button>
          </el-popover>-->
          <el-input
              v-model="searchValue"
              class="input-with-select"
              clearable
              placeholder="请输入申请单位名称"
              style="width: 240px"
              @clear="search"
              @keyup.enter.native="search"
          >
            <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
            ></el-button>
          </el-input>
          <label>保密资格证:</label>
          <el-select
              v-model="secretCrt"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="item in checkList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            ></el-option>
          </el-select>
          <label>生产许可证:</label>
          <el-select
              v-model="prodCrt"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
          <label>资格名录:</label>
          <el-select
              v-model="qualDir"
              clearable
              placeholder="全部"
              style="width: 140px"
              @change="search"
          >
            <el-option
                v-for="item in options.cooperation"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="achievement-table">
          <el-table
              ref="multipleTable"
              :data="tableData"
              :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
              class="table"
              style="width: 100%"
              @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column
                align="center"
                label="序号"
                type="index"
                width="150"
            >
              <template slot-scope="scope">
                <span>{{
                    scope.$index + (current_page - 1) * per_page + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="申请单位"
                prop="companyName"
            ></el-table-column>
            <el-table-column align="center" label="办理内容">
              <template slot-scope="scope">
                <span>
                  <a
                      :title="getCrt(scope.row, 'secretCrt,prodCrt,qualDir')"
                      class="ellipsis-01"
                      href="javascript:;"
                  >{{ getCrt(scope.row, "secretCrt,prodCrt,qualDir") }}</a
                  >
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="备注">
              <template slot-scope="scope">
                <el-popover
                    :content="scope.row.content"
                    placement="bottom-start"
                    title=""
                    trigger="hover"
                    width="200"
                >
                  <i
                      slot="reference"
                      class="el-icon-s-comment"
                      style="font-size: 28px; color: #409eff"
                  ></i>
                </el-popover>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="date_time" label="申请时间" align="center"></el-table-column> -->
            <el-table-column
                align="center"
                label="审核状态"
                prop="examineStatus"
            >
              <template slot-scope="scope">
                <el-tag v-show="scope.row.examineStatus === 1" type="success"
                >通过
                </el-tag
                >
                <el-tag v-show="scope.row.examineStatus === 2" type="info"
                >未通过
                </el-tag
                >
                <el-tag v-show="scope.row.examineStatus === 3" type="danger"
                >待审核
                </el-tag
                >
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="240">
              <template slot-scope="scope">
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="primary"
                    @click="handleEdit(scope.$index, scope.row)"
                >审核
                </el-button
                >
                <el-button
                    class="mini_btn"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
            :current-page.sync="current_page"
            :page-size="per_page"
            :total="total"
            layout="total,prev, pager, next"
            style="text-align: left; margin: 20px 0"
            @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </CommonLayout>
    <el-dialog
        :close-on-click-modal="false"
        :title="Title"
        :visible.sync="dialogFormVisible"
        width="80%"
    >
      <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="demo-ruleForm"
          label-width="100px"
      >
        <div class="form-title">需求来源</div>
        <!-- <el-row>
          <el-form-item label="单位名称" prop="unit">
            <el-input v-model="form.unit" placeholder="请输入单位名称" clearable></el-input>
          </el-form-item>
        </el-row>-->
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位名称" prop="companyName">
              <el-input
                  v-model="form.companyName"
                  clearable
                  disabled
                  placeholder="请输入单位名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位地址" prop="companyAddr">
              <el-input
                  v-model="form.companyAddr"
                  clearable
                  disabled
                  placeholder="请输入单位地址"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactName">
              <el-input
                  v-model="form.contactName"
                  clearable
                  disabled
                  placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                  v-model="form.contactPhone"
                  clearable
                  disabled
                  placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item class="w100 t-left" label="短信通知" prop="isSms">
              <el-radio-group v-model="form.isSms" disabled>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办公电话" prop="workPhone">
              <el-input
                  v-model="form.workPhone"
                  clearable
                  disabled
                  placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">代办内容</div>
        <el-row>
          <el-col :span="12">
            <el-form-item
                class="w100 t-left"
                label="保密资格证"
                prop="secretCrt"
            >
              <el-radio-group v-model="form.secretCrt" disabled>
                <el-radio label="001">一级</el-radio>
                <el-radio label="002">二级</el-radio>
                <el-radio label="003">三级</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                class="w100 t-left"
                label="价格 : "
                prop="secret_price"
            >
              <span>100</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item class="w100 t-left" label="生产许可证">
              <el-radio-group v-model="form.prodCrt" disabled>
                <el-radio label="001">第一类</el-radio>
                <el-radio label="002">第二类</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="w100 t-left" label="价格 : ">
              <span>150</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item class="w100 t-left" label="资格名录">
              <el-radio-group v-model="form.qualDir" disabled>
                <el-radio label="001">A类</el-radio>
                <el-radio label="002">B类</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="w100 t-left" label="价格 : ">
              <span>180</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-title">需求简介</div>
        <el-row>
          <el-form-item label="需求简介" prop="content">
            <!-- <editor
              v-model="form.content"
              :upload-url="uploadURL"
              :img-show-url="imgUrl"
              :disabled="isBoo==2"
            ></editor>-->
            <el-input
                v-model="form.content"
                :rows="4"
                disabled
                placeholder="请输入需求简介"
                type="textarea"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="审核状态" prop="examineStatus" style="text-align:left">
              <el-select v-model="form.examineStatus" placeholder="请选择">
                <el-option
                  v-for="item in showOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->

          <!-- <el-col :span="12" style="text-align:right">
            <el-form-item label="关键字" prop="key_name">
              <el-select
                style="width:100%"
                v-model="form.key_name"
                filterable
                allow-create
                default-first-option
                placeholder="请选择文章标签"
              >
                <el-option
                  v-for="item in Resource_Keys"
                  :key="item.key"
                  :label="item.key"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row class="show-step">
          <el-form-item label="修改状态 : ">
            <el-steps :active="active" align-center finish-status="success">
              <el-step
                  v-for="(item, index) in stepsOption"
                  :key="index"
                  :title="item.label"
                  @click.native="nextStep(item)"
              ></el-step>
            </el-steps>
            <el-col
                v-for="(item, index) in stepBtnList"
                :key="'opt' + index"
                :span="4"
                class="flex-around-column"
            >
              <el-upload
                  v-if="item.isUpload"
                  :action="uploadURL"
                  :auto-upload="true"
                  :file-list="stepBtnList[index].fileList"
                  :limit="3"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-success="onSuccess"
                  accept=".jpg, .jpeg, .png, .pdf"
                  class="upload-demo mt-10"
                  multiple
              >
                <el-button
                    :disabled="active < index + 1"
                    size="small"
                    type="primary"
                    @click.native="getCueIndex(index)"
                >{{ item.isUpload }}
                </el-button
                >
              </el-upload>

              <span class="mt-10">{{ item.tip }}</span>
              <div class="mt-10">
                <el-radio
                    v-model="stepBtnList[index]['isFinsh']"
                    :disabled="active < index + 1"
                    label="1"
                    @change="changeFn(index)"
                >是
                </el-radio
                >
                <el-radio
                    v-model="stepBtnList[index]['isFinsh']"
                    :disabled="active < index + 1"
                    label="2"
                    @change="changeFn(index)"
                >否
                </el-radio
                >
              </div>
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center">
            <el-button type="primary" @click="submitForm('form')"
            >提交
            </el-button
            >
            <el-button @click="closeForm('form')">取消</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
        :visible.sync="isDownloadData"
        center
        title="资料管理"
        width="30%"
    >
      <el-row>
        <el-col :span="4">
          <el-upload
              :action="uploadURL"
              :on-success="onManage"
              :show-file-list="false"
              accept=".doc, .docx, .pdf"
              class="upload-demo"
              multiple
          >
            <el-button type="primary">新增</el-button>
          </el-upload>
        </el-col>
        <el-col :span="6">
          <el-button type="danger" @click="deleteAll('manage')"
          >批量删除
          </el-button
          >
        </el-col>
      </el-row>
      <el-table :data="manageData" @selection-change="selectManage">
        <el-table-column
            align="center"
            type="selection"
            width="50"
        ></el-table-column>
        <el-table-column
            align="center"
            label="序号"
            type="index"
            width="50"
        ></el-table-column>
        <el-table-column
            align="center"
            label="资料名称"
            prop="name"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row, 'manage')"
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDownloadData = false">取 消</el-button>
        <el-button type="primary" @click="downloadSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../components/common-layout.vue";
import editor from "../../components/tinymce-editor/tinymce-editor";
import dateformat from "../../../utils/dateformat";
import {FunDownload, GetUrlName} from "../../utils/tool";

export default {
  components: {
    editor,
    CommonLayout,
  },
  data() {
    return {
      fileList: [],
      manageData: [],

      curIndex: 0,
      resetStepBtnList: [],

      active: 1,
      stepBtnList: [
        {
          tip: "是否对该业务已完成受理",
          isFinsh: "",
          isUpload: "",
          fileList: [],
        },
        {
          tip: "是否已完成服务合共同签订",
          isFinsh: "",
          isUpload: "上传服务合同",
          fileList: [],
        },
        {
          tip: "是否已提交申请材料",
          isFinsh: "",
          isUpload: "上传申请材料",
          fileList: [],
        },
        {
          tip: "是否已完成书面审查",
          isFinsh: "",
          isUpload: "",
          fileList: [],
        },
        {
          tip: "是否已完成现场审查",
          isFinsh: "",
          isUpload: "",
          fileList: [],
        },
        {
          tip: "业务是否已办理完结",
          isFinsh: "",
          isUpload: "上传证书",
          fileList: [],
        },
      ],

      isBoo: 2,
      times: "",
      visible: false,
      secretCrt: "",
      prodCrt: "",
      naturalValue: "",
      typeValue: "",
      qualDir: "",
      deleteRow: "",
      total: 10,
      per_page: 10,
      current_page: 1,
      checkAll: false,
      isIndeterminate: false,
      image: "",
      searchValue: "",
      dialogFormVisible: false,
      Title: "新增",
      tableData: [],
      Resource_Keys: [],
      timeProcess: {},
      form: {
        companyName: "",
        companyAddr: "",
        contactName: "",
        contactPhone: "",
        // Officephone: "",
        isSms: "2",
        content: "",
        prodCrt: "001",
        qualDir: "001",
        secretCrt: "001",
        examineStatus: 0,
        keywords: "测试",
        workPhone: "",
      },
      stepsOption: [
        {
          value: 1,
          label: "受理",
        },
        {
          value: 2,
          label: "签订服务合同",
        },
        {
          value: 3,
          label: "提交申请材料",
        },
        {
          value: 4,
          label: "书面审查",
        },
        {
          value: 5,
          label: "现场审查",
        },
        {
          value: 6,
          label: "获取证书",
        },
      ],
      showOptions: [
        {
          value: 1,
          label: "已受理",
        },
        {
          value: 2,
          label: "未受理",
        },
        {
          value: 3,
          label: "已签订服务合同",
        },
        {
          value: 4,
          label: "未签订服务合同",
        },
        {
          value: 5,
          label: "已提交申请材料",
        },
        {
          value: 6,
          label: "未提交申请材料",
        },
        {
          value: 7,
          label: "已完成书面审查",
        },
        {
          value: 8,
          label: "未完成书面审查",
        },
        {
          value: 9,
          label: "已完成现场审查",
        },
        {
          value: 10,
          label: "未完成现场审查",
        },
        {
          value: 11,
          label: "已获取证书",
        },
        {
          value: 12,
          label: "未获取证书",
        },
      ],
      options: {
        cooperation: [
          {
            value: "001",
            label: "A类",
          },
          {
            value: "002",
            label: "B类",
          },
        ],
      },
      checkList: [
        {
          id: "001",
          name: "一级",
        },
        {
          id: "002",
          name: "二级",
        },
        {
          id: "003",
          name: "三级",
        },
      ],
      typeOptions: [
        {
          value: "001",
          label: "第一类",
        },
        {
          value: "002",
          label: "第二类",
        },
      ],
      rules: {},
      isDownloadData: false,
    };
  },
  created() {
    this.getData(`${urlConfig.devUrl}apij2/admin-api/trade/war-industry/page`, {page: this.current_page});
    this.getMange();
    // this.getKey();
    this.resetStepBtnList = JSON.stringify(this.stepBtnList);
  },
  methods: {
    getCrt(item, prop) {
      let arr = [
        "武器装备科研生产单位保密资格证",
        "武器装备科研生产许可证",
        "武器承制单位资格名录",
      ];
      let tmp = prop.split(",");
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(item[tmp[i]] ? arr[i] : "");
      }
      res = res.filter((d) => d).join(",");
      return res;
    },
    // 材料管理
    onManage(response, file, fileList) {
      this.addMange(response);
    },
    async addMange(response) {
      let list = response.data.store_result.split("__!");
      let name = list[list.length - 1];
      let url = response.data.store_result;
      let data = {
        name: name,
        url: url,
      };
      let res = await this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/war-industry-data-manage/create`, data);
      if (res.code === 0) {
        this.$message.success("上传成功");
        await this.getMange();
      }
    },

    async getMange() {
      let res = await this.http.post(
          `${urlConfig.devUrl}apij2/admin-api/trade/war-industry-data-manage/page`,
          {
            is_page: 1,
            isDel: 0
          }
      );
      if (res.code === 0) {
        this.manageData = res.data.data;
      }
    },
    handleChange() {
    },
    downloadSubmit() {
      this.isDownloadData = false;
    },
    downloadData() {
      this.getMange();
      this.isDownloadData = true;
    },
    getCueIndex(index) {
      this.curIndex = index;
    },
    // 设置操作步骤时间
    timeFn(status, flag = true) {
      let datas = {};
      let date = flag
          ? dateformat.format(new Date(), "yyyy-MM-dd hh:mm:ss")
          : "";
      switch (status) {
        case 1:
        case 2:
          datas.server_contract_time = "";
          datas.apply_material_time = "";
          datas.write_review_time = "";
          datas.scene_review_time = "";
          datas.gain_licence_time = "";
          datas.deal_time = date;
          break;
        case 3:
        case 4:
          datas.apply_material_time = "";
          datas.write_review_time = "";
          datas.scene_review_time = "";
          datas.gain_licence_time = "";
          datas.server_contract_time = date;
          break;
        case 5:
        case 6:
          datas.write_review_time = "";
          datas.scene_review_time = "";
          datas.gain_licence_time = "";
          datas.apply_material_time = date;
          break;
        case 7:
        case 8:
          datas.scene_review_time = "";
          datas.gain_licence_time = "";
          datas.write_review_time = date;
          break;
        case 9:
        case 10:
          datas.gain_licence_time = "";
          datas.scene_review_time = date;
          break;
        case 11:
        case 12:
          datas.gain_licence_time = date;
          break;
        default:
          break;
      }
      this.timeProcess = Object.assign({}, this.timeProcess, datas);
    },

    // 便利清空 选中状态 避免 跳步撤回 造成 状态未重置
    skipClean(examineStatus) {
      this.stepBtnList = this.stepBtnList.map((el, index) => {
        if (index <= examineStatus) {
          return el;
        } else {
          el.isFinsh = "";
          // el.fileList = [];
          return el;
        }
      });
    },
    changeFn(index) {
      // 获取当前激活步骤
      let isFinsh = this.stepBtnList[index].isFinsh;
      if (isFinsh === "1") {
        // debugger

        // 激活当前步骤
        this.form.examineStatus = index * 2 + 1;
        this.timeFn(this.form.examineStatus);
        this.skipClean(index);
        if (index === 5) {
          this.stepBtnList[index].isFinsh = "1";
          this.$set(this.stepBtnList, index, this.stepBtnList[index]);
          return;
        }
        this.stepBtnList[index + 1].isFinsh = "";
        this.stepBtnList[index].isFinsh = "1";
        this.$set(this.stepBtnList, index + 1, this.stepBtnList[index + 1]);
        this.$set(this.stepBtnList, index, this.stepBtnList[index]);
        this.active = this.active + 1;
      } else {
        // 否定当前步骤状态
        this.form.examineStatus = index * 2 + 2;
        this.timeFn(this.form.examineStatus, false);
        this.skipClean(index);

        if (index === 0) {
          this.stepBtnList[index].isFinsh = "2";
          this.$set(this.stepBtnList, index, this.stepBtnList[index]);
          this.active = 1;

          return;
        }

        this.active =
            index + 1 > this.stepBtnList.length
                ? this.stepBtnList.length
                : index + 1;
        this.stepBtnList[index].isFinsh = "2";
        this.stepBtnList[index - 1].isFinsh = "1";
        // this.stepBtnList[index].fileList = [];
        // this.stepBtnList[index - 1].fileList = [];
        this.$set(this.stepBtnList, index, this.stepBtnList[index]);
        this.$set(this.stepBtnList, index - 1, this.stepBtnList[index - 1]);
      }
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.stepBtnList[this.active - 1].fileList = fileList;
    },
    onSuccess(response, file, fileList) {
      this.stepBtnList[this.curIndex].fileList = fileList.map((el) => {
        console.log(el);

        return {
          name: el.name,
          url: el.url || el.response?.data.store_result,
          uid: el.uid,
        };
      });
    },
    handlePreview(file) {
      FunDownload(
          this.imgUrl + (file?.url || file.response.data.store_result),
          file.name
      );
      console.log(file);
    },
    // 状态审核下一步
    nextStep(item) {
      console.log("点击上传事件", item.value);
    },

    //导出
    exportOut() {
      let url = "";
      if (this.times) {
        url =
            window.urlConfig.url +
            "war_industry_Export?time_type=1&start_datetime=" +
            this.times[0] +
            "&end_datetime=" +
            this.times[1];
      } else {
        url = window.urlConfig.url + "war_industry_Export";
      }
      var a = document.createElement("a");
      a.href = url;
      a.download = "";
      a.click();
      this.visible = false;
      this.times = null;
    },
    getData(url, data) {
      this.http.post(url, data).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page;
          for (let i = 0; i < this.tableData.length; i++) {
            for (let j = 0; j < this.showOptions.length; j++) {
              if (
                  this.tableData[i].examineStatus === this.showOptions[j].value
              ) {
                this.tableData[i].examineStatus = this.showOptions[j].label;
              }
            }
          }
        }
      });
    },
    //新增
    addAch() {
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.dialogFormVisible = true;
      this.Title = "新增";
      this.form = {
        companyName: "",
        companyAddr: "",
        contactName: "",
        contactPhone: "",
        // Officephone: "",
        isSms: "2",
        content: "",
        prodCrt: "001",
        qualDir: "001",
        secretCrt: "001",
        examineStatus: "",
        keywords: "测试",
        workPhone: "",
      };
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.active = 1;
      this.stepBtnList = JSON.parse(this.resetStepBtnList);
      this.Title = "编辑";
      this.showOptions.forEach((item) => {
        item.disabled = false;
      });
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/trade/war-industry-data-manage/get?id=${row.id}`).then((res) => {
        if (res.code === 0) {
          this.form = res.data;
          this.active =
              Math.ceil(this.form.examineStatus / 2) + 1 >
              this.stepBtnList.length
                  ? this.stepBtnList.length
                  : Math.ceil(this.form.examineStatus / 2) + 1;

          for (let i = 0; i < this.form.examineStatus; i++) {
            if (
                i === this.form.examineStatus - 1 &&
                !(this.form.examineStatus % 2)
            ) {
              this.active = this.active - 1;
              this.stepBtnList[parseInt(i / 2)].isFinsh = "2";
            } else {
              this.stepBtnList[parseInt(i / 2)].isFinsh = "1";
            }
          }

          // this.$set(this.stepBtnList,this.active + 1, this.stepBtnList[this.active + 1])
        }
        this.stepBtnList[1].fileList = this.form.server_contract
            .split(",")
            .map((el) => {
              return {
                url: el,
                uid: new Date().valueOf(),
                name: GetUrlName(el),
              };
            })
            .filter((d) => d.url);
        this.stepBtnList[2].fileList = this.form.apply_material
            .split(",")
            .map((el) => {
              return {
                url: el,
                uid: new Date().valueOf(),
                name: GetUrlName(el),
              };
            })
            .filter((d) => d.url);
        this.stepBtnList[5].fileList = this.form.certificate
            .split(",")
            .map((el) => {
              return {
                url: el,
                uid: new Date().valueOf(),
                name: GetUrlName(el),
              };
            })
            .filter((d) => d.url);
        console.log(this.stepBtnList);
        this.$set(this.stepBtnList, 1, this.stepBtnList[1]);
        this.$set(this.stepBtnList, 2, this.stepBtnList[2]);
        this.$set(this.stepBtnList, 5, this.stepBtnList[5]);
      });
    },
    //翻页
    handleCurrentChange(e) {
      this.getData(
          `${urlConfig.devUrl}apij2/admin-api/trade/war-industry-data-manage/page`,
          {
            keyword: this.searchValue,
            page: e,
            secretCrt: this.secretCrt,
            prodCrt: this.prodCrt,
            qualDir: this.qualDir
          }
      );
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length !== 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //选择
    selectManage(selection) {
      this.deleteRow = "";
      if (selection.length !== 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //删除
    handleDelete(index, row, type = "") {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
          .then(() => {
            let url = "";
            if (type === "manage") {
              url = `${urlConfig.devUrl}apij2/admin-api/trade/war-industry-data-manage/delete?id=${row.id}`
            } else {
              url = `${urlConfig.devUrl}apij2/admin-api/trade/war-industry/delete?id=${row.id}`
            }

            this.http.delete(url,).then((res) => {
              if (res.code === 0) {
                this.search();
                // this.getData(`war_industry`);
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
                if (type === "manage") {
                  this.getMange();
                }
              } else {
                this.$message({
                  message: "失败！",
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    //批量删除
    deleteAll(type = "") {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
            .then(() => {
              let url = "";
              if (type === "manage") {
                url = `${urlConfig.devUrl}apij2/admin-api/trade/war-industry-data-manage/deleteAll?ids=${this.deleteRow}`
              } else {
                url = `${urlConfig.devUrl}apij2/admin-api/trade/war-industry/deleteAll?ids=${this.deleteRow}`
              }
              this.http
                  .delete(url)
                  .then((res) => {
                    if (res.code === 0) {
                      this.search();
                      this.$message({
                        type: "success",
                        message: "删除成功",
                      });
                      if (type === "manage") {
                        this.getMange();
                      }
                    } else {
                      this.$message({
                        message: "失败！",
                        type: "error",
                      });
                    }
                  });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的记录",
        });
      }
    },
    subData(name) {
      let obj = JSON.parse(JSON.stringify(this.form));
      // if (!this.form.id) {
      //   this.http.post("war_industry", obj).then(res => {
      //     if (res.code == 0) {
      //       this.search();
      //       // this.getData("war_industry");
      //       // this.getKey();
      //       this.$message({
      //         type: "success",
      //         message: "新增成功"
      //       });
      //       this.dialogFormVisible = false;
      //       this.$refs[name].resetFields();
      //     }
      //   });
      // } else {
      let datas = {};
      datas.examineStatus = this.form.examineStatus;

      datas = Object.assign({}, datas, this.timeProcess);

      datas.server_contract = this.stepBtnList[1].fileList
          .map((el) => el.url)
          .join(",");
      datas.apply_material = this.stepBtnList[2].fileList
          .map((el) => el.url)
          .join(",");
      datas.certificate = this.stepBtnList[5].fileList
          .map((el) => el.url)
          .join(",");

      if (datas.examineStatus === 1 || datas.examineStatus === 2) {
        let work1 = `${
            this.form.secretCrt === "001"
                ? "武器装备科研生产单位保密资格证一级"
                : this.form.secretCrt === "002"
                    ? "武器装备科研生产单位保密资格证二级"
                    : this.form.secretCrt === "003"
                        ? "武器装备科研生产单位保密资格证三级"
                        : ""
        }`;
        let work2 = `${
            this.form.prodCrt === "001"
                ? "武器装备科研生产许可证第一类"
                : this.form.prodCrt === "002"
                    ? "武器装备科研生产许可证第二类"
                    : ""
        }`;
        let work3 = `${
            this.form.qualDir === "001"
                ? "装备承制单位资格名录A类"
                : this.form.qualDir === "002"
                    ? "装备承制单位资格名录B类"
                    : ""
        }`;
        let work = work1 + work2 + work3;
        let obj = {
          phone: this.form.contactPhone,
          content: `尊敬的${this.form.contactName.substring(
              0,
              1
          )}先生/女士：您好！您已在兰州科技大市场管理有限责任公司【甘肃省自主创新试验示范创新服务平台】成功预约${work}代办业务，目前业务${this.form.isSms == 1 ? '已受理' : '未被受理'}，业务办理进程请登录【甘肃省自主创新试验示范创新服务平台】进入个人中心查看。`,
        };
        if (this.form.isSms === 1) {
          this.http.post("code/common_send", obj);
        }
      }
      datas.id = this.form.id;
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/war-industry/update`, datas).then((res) => {
        if (res.code === 0) {
          this.search();
          // this.getData("war_industry");
          // this.getKey();
          this.$message({
            type: "success",
            message: "审核成功",
          });
          this.dialogFormVisible = false;
          this.$refs[name].resetFields();
        }
      });
      // }
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.subData(name);
        } else {
          return false;
        }
      });
    },
    //数组去重
    unique(arr) {
      return arr.filter((ele, index, array) => {
        return array.indexOf(ele) === index;
      });
    },
    //关闭
    closeForm(name) {
      this.$refs[name].resetFields();
      this.checkAll = false;
      this.isIndeterminate = false;
      this.dialogFormVisible = false;
    },
    //查找
    search() {
      this.getData(
          `${urlConfig.devUrl}apij2/admin-api/trade/war-industry/page`,
          {
            keyword: this.searchValue,
            page: 1,
            secretCrt: this.secretCrt,
            prodCrt: this.prodCrt,
            qualDir: this.qualDir
          }
      );
    },
    //审核
    release(row, type) {
      let obj = {
        examineStatus: type,
      };
      this.$jsonp(
          "https://restapi.amap.com/v3/place/text?key=cd745e505b8ce710bfb566c298caba0c&keywords=" +
          row.address.detailed +
          "&city=" +
          row.address.city.value +
          "&children=1&offset=20&page=1&extensions=all"
      )
          .then((json) => {
            let arr = json.pois[0].location.split(",");
            obj.longitude = arr[0];
            obj.latitude = arr[1];
            obj.id = row.id;
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/war-industry/update`, obj).then((res) => {
              if (res.code === 0) {
                if (type === 1) {
                  this.$message.success("审核通过");
                } else {
                  this.$message.success("审核不通过");
                }
                this.search();
              }
            });
          })
          .catch((err) => {
            this.$message.error("未获取到经纬度,请查看地址是否完整");
          });
    },
    //富文本
    getQuillData(val) {
      this.form.content = val;
    },
    //城市选择
    citySelected(e) {
      this.form.address = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.down-data {
  color: orange;
}

.achievement {
  width: 100%;
  height: 100%;

  .achievement-search {
    width: 100%;
    text-align: left;
    // margin-top: 20px;
    .el-select {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-cascader {
      margin: 0 15px;

      .el-input {
        margin: 0;
      }
    }

    .el-input {
      margin: 0 15px;
    }
  }

  .achievement-table {
    width: 100%;
    margin-top: 20px;
    // border: 1px solid #eef1f6;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #0572a4;
    border-left: 5px solid #0572a4;
    border-bottom: 1px solid #0572a4;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  /*上传图片*/
  .is_border {
    // border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: center;
    width: 243px;
    height: 198px;
  }

  /deep/ .el-upload {
    // border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  /deep/ .el-upload--text {
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .show-step {
    text-align: left;

    /deep/ .el-form-item__content {
      line-height: 100%;
      position: relative;
      font-size: 14px;
    }
  }

  .upload-demo {
    border: none;
    width: 100%;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
